import { ExpandMoreOutlined } from "@mui/icons-material";
import { Accordion, AccordionDetails, AccordionSummary, Typography } from "@mui/material";


export const AccordionForms = ({ children, title, width, height }) => {
    if (height == null) {
        height = 110;
    }

    return (
        <Accordion style={{ width: width, borderRadius: "16px" }} defaultExpanded={true} elevation={3}>
            <AccordionSummary
                expandIcon={<ExpandMoreOutlined />}
                aria-controls="panel1-content"
                id="panel1-header"
                style={{ minHeight: "16px", height: "16px" }}

            >
                <Typography
                    style={{
                        fontSize: '14px',
                        fontWeight: 400,
                        width: '100%',
                        display: 'flex',
                        justifyContent: 'start',
                        marginTop: "5px",
                        marginLeft: "5px",
                        color: 'rgb(95, 95, 95)'
                    }}
                >
                    {title}
                </Typography>
            </AccordionSummary>
            <AccordionDetails
                style={{
                    overflowY: 'scroll',
                    height: height
                }}
            >
                {children}
            </AccordionDetails>
        </Accordion>
    );
}